module.exports = __webpack_public_path__ + "img/clock-blue.155621af.svg";